import styles from '../ApplicationInformation.module.scss';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import HtmlLinkButton from './AppInfoedit/htmlLinkInsert';
import LocationsEdit from './AppInfoedit/LocationsEdit';
import ContactsEdit from './AppInfoedit/ContactsEdit';

const AppInfoEdit = ({
	selectedApp,
	userCanEdit,
	copyOfApp,
	setCopyOfApp,
	locationOptions,
}) => {
	const handleChange = e => {
		setCopyOfApp({
			...copyOfApp,
			appInfo: {
				...copyOfApp.appInfo,
				[e.target.name]: e.target.value,
			},
		});
	};

	const [activeElement, setActiveElement] = useState(null);

	const descriptionRef = useRef();
	const shortdescriptionRef = useRef();
	const aliasRef = useRef();
	const typicalUsersRef = useRef();
	const trainingRef = useRef();
	const quickStartRef = useRef();
	// const howToGetRef = useRef();
	const helpRef = useRef();
	const addInfoRef = useRef();
	const managingdeptRef = useRef();

	//resolve error message cause by null value on text area by explicitly converting to undefined
	const resolveTextAreaNull = value => {
		if (value === null) {
			return undefined;
		} else return value;
	};

	//text area character limits determined from max size of column in database
	return selectedApp && userCanEdit ? (
		<div className={styles.AppDetailsSection}>
			<div className={classNames([styles.appName, styles.section])}>
				<div className={styles.detailLabel}>
					<p>
						Application Name{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp.appInfo?.applicationName?.length
								? copyOfApp.appInfo?.applicationName?.length
								: 0}
							/{64})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(
						copyOfApp.appInfo.applicationName
					)}
					onChange={e => handleChange(e)}
					name='applicationName'
					maxLength={64}
					disabled
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
			</div>

			<div className={classNames([styles.description, styles.section])}>
				<div className={styles.detailLabel}>
					<p>
						Description{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp.appInfo?.description?.length
								? copyOfApp.appInfo?.description?.length
								: 0}
							/{2048})
						</span>
					</p>
				</div>

				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(copyOfApp.appInfo.description)}
					onChange={e => handleChange(e)}
					name='description'
					maxLength={2048}
					ref={descriptionRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
				<HtmlLinkButton
					refElement={descriptionRef}
					className={styles.mdLinkButton}
					handleChange={handleChange}
					activeElement={activeElement}
				/>
			</div>

			<div
				className={classNames([
					styles.shortDescription,
					styles.section,
				])}
			>
				<div className={styles.detailLabel}>
					<p>
						Short Description{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp.appInfo.shortDescription?.length
								? copyOfApp.appInfo.shortDescription?.length
								: 0}{' '}
							/{128})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(
						copyOfApp.appInfo.shortDescription
					)}
					onChange={e => handleChange(e)}
					name='shortDescription'
					maxLength={128}
					ref={shortdescriptionRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
				<HtmlLinkButton
					refElement={shortdescriptionRef}
					className={styles.mdLinkButton}
					handleChange={handleChange}
					activeElement={activeElement}
				/>
			</div>

			<div className={classNames([styles.alias, styles.section])}>
				<div className={styles.detailLabel}>
					<p>
						Alias{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp.appInfo.alias?.length
								? copyOfApp.appInfo.alias?.length
								: 0}
							/{255})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(copyOfApp.appInfo.alias)}
					onChange={e => handleChange(e)}
					name='alias'
					maxLength={255}
					ref={aliasRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
			</div>

			<div className={classNames([styles.training, styles.section])}>
				<div className={styles.detailLabel}>
					<p>
						Training Information{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp.appInfo.training?.length
								? copyOfApp.appInfo.training?.length
								: 0}
							/{512})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(copyOfApp.appInfo.training)}
					onChange={e => handleChange(e)}
					name='training'
					maxLength={512}
					ref={trainingRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
				<HtmlLinkButton
					refElement={trainingRef}
					className={styles.mdLinkButton}
					handleChange={handleChange}
					activeElement={activeElement}
				/>
			</div>

			<div className={classNames([styles.typicalUsers, styles.section])}>
				<div className={styles.detailLabel}>
					<p>
						Typical Users{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp?.appInfo?.typicalUsers?.length
								? copyOfApp?.appInfo?.typicalUsers?.length
								: 0}
							/{128})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(copyOfApp.appInfo.typicalUsers)}
					onChange={e => handleChange(e)}
					name='typicalUsers'
					maxLength={128}
					ref={typicalUsersRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
			</div>

			<div className={classNames([styles.quickStart, styles.section])}>
				<div className={styles.detailLabel}>
					<p>
						Next Steps{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp.appInfo.quickStart?.length
								? copyOfApp.appInfo.quickStart?.length
								: 0}
							/{512})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(copyOfApp.appInfo.quickStart)}
					onChange={e => handleChange(e)}
					name='quickStart'
					maxLength={512}
					ref={quickStartRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
				<HtmlLinkButton
					refElement={quickStartRef}
					className={styles.mdLinkButton}
					handleChange={handleChange}
					activeElement={activeElement}
				/>
			</div>
			<div className={classNames([styles.locations, styles.section])}>
				<div className={styles.detailLabel}>Locations </div>
				<LocationsEdit
					copyOfApp={copyOfApp}
					setCopyOfApp={setCopyOfApp}
					locationOptions={locationOptions}
				/>
			</div>
			{/* <div className={classNames([styles.howToGet, styles.section])}>
				<div className={styles.detailLabel}>
					<p>
						How To Get{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp?.appInfo?.howToGet?.length
								? copyOfApp?.appInfo?.howToGet?.length
								: 0}
							/{255})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(copyOfApp.appInfo.howToGet)}
					onChange={e => handleChange(e)}
					name='howToGet'
					maxLength={255}
					ref={howToGetRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
				<HtmlLinkButton
					refElement={howToGetRef}
					className={styles.mdLinkButton}
					handleChange={handleChange}
					activeElement={activeElement}
				/>
			</div> */}

			<div className={classNames([styles.help, styles.section])}>
				<div className={styles.detailLabel}>
					<p>
						Support{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp.appInfo.help?.length
								? copyOfApp.appInfo.help?.length
								: 0}
							/{255})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(copyOfApp.appInfo.help)}
					onChange={e => handleChange(e)}
					name='help'
					maxLength={255}
					ref={helpRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
				<HtmlLinkButton
					refElement={helpRef}
					className={styles.mdLinkButton}
					handleChange={handleChange}
					activeElement={activeElement}
				/>
			</div>

			<div
				className={classNames([
					styles.additionalInformation,
					styles.section,
				])}
			>
				<div className={styles.detailLabel}>
					<p>
						Additional Information{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp?.appInfo?.additionalInformation?.length
								? copyOfApp?.appInfo?.additionalInformation
										?.length
								: 0}
							/{256})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(
						copyOfApp.appInfo.additionalInformation
					)}
					onChange={e => handleChange(e)}
					name='additionalInformation'
					maxLength={256}
					ref={addInfoRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
				<HtmlLinkButton
					refElement={addInfoRef}
					className={styles.mdLinkButton}
					handleChange={handleChange}
					activeElement={activeElement}
				/>
			</div>

			<div
				className={classNames([
					styles.managingDepartment,
					styles.section,
				])}
			>
				<div className={styles.detailLabel}>
					<p>
						Managing Department{' '}
						<span className={styles.characterCount}>
							(
							{copyOfApp.appInfo.managingDepartment?.length
								? copyOfApp.appInfo.managingDepartment?.length
								: 0}
							/{64})
						</span>
					</p>
				</div>
				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(
						copyOfApp.appInfo.managingDepartment
					)}
					onChange={e => handleChange(e)}
					name='managingDepartment'
					maxLength={64}
					ref={managingdeptRef}
					rows={5}
					onFocus={e => setActiveElement(e.target)}
				/>
				<HtmlLinkButton
					refElement={managingdeptRef}
					activeElement={activeElement}
					className={styles.mdLinkButton}
					handleChange={handleChange}
				/>
			</div>

			<div
				className={classNames([styles.securityContact, styles.section])}
			>
				<div className={styles.detailLabel}>Security Contact</div>

				<ContactsEdit
					copyOfApp={copyOfApp}
					setCopyOfApp={setCopyOfApp}
					contactTypeKey='securityContact'
					buttonLabel='Edit Security Contacts'
				/>
			</div>

			<div
				className={classNames([styles.privacyContact, styles.section])}
			>
				<div className={styles.detailLabel}>Privacy Contact</div>
				<ContactsEdit
					copyOfApp={copyOfApp}
					setCopyOfApp={setCopyOfApp}
					contactTypeKey='privacyContact'
					buttonLabel='Edit Privacy Contacts'
				/>
			</div>

			<div className={classNames([styles.owners, styles.section])}>
				<div className={styles.detailLabel}>Owners</div>

				<ContactsEdit
					copyOfApp={copyOfApp}
					setCopyOfApp={setCopyOfApp}
					contactTypeKey='owners'
					buttonLabel='Edit Owners'
				/>
			</div>

			<div className={classNames([styles.technicalTeam, styles.section])}>
				<div className={styles.detailLabel}>Technical Team</div>
				<ContactsEdit
					copyOfApp={copyOfApp}
					setCopyOfApp={setCopyOfApp}
					contactTypeKey='technicalTeam'
					buttonLabel='Edit Technical Team'
				/>
			</div>
		</div>
	) : null;
};

export default AppInfoEdit;
